<template>
  <div>
    <loading :active.sync="loading"></loading>
    <div class="row">
      <div class="col pb-2">
        <div class="d-inline">
          <i class="fas fa-tags fa-rotate-90 fa-align-left fa-2x"></i>
        </div>
        <h2 class="big-text d-inline">{{ name }}</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8 top-border">
        <h5 class="biggish-text mt-1">What You'll Get</h5>
        <p>{{ details }}</p>
        <h5 class="biggish-text mt-1">Legal</h5>
        <p>{{ legal }}</p>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div v-if="couponExpiration" class="col-6 text-center left-border top-border">
            <i class="far fa-clock clock-icon"></i>
          </div>
          <div class="col-6 text-center side-borders top-border">
            <h2 class="display-number number-available">{{ numberAvailable }}</h2>
          </div>
        </div>
        <div class="row">
          <div v-if="couponExpiration" class="col-6 text-center left-border">
            <p>Limited Time</p>
          </div>
          <div class="col-6 text-center side-borders">
            <p>Available</p>
          </div>
        </div>
        <div class="row side-borders top-border pb-1">
          <div class="col text-center big-text">
            <p class="list-price mr-2">${{ listPrice }}</p>
            <p class="discounted-price">${{ discountedPrice }}</p>
          </div>
        </div>
        <div class="row side-borders">
          <div class="col text-center">
            <div class="discount-tag mb-1 pl-1 pr-1">{{ priceDifference }}% OFF</div>
          </div>
        </div>
        <div class="row side-borders bottom-border p-1">
          <div class="col">
            <button v-on:click="claim" class="btn btn-primary">Claim</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  data () {
    return {
      loading: false
    }
  },
  components: {
    Loading
  },
  props: {
    businessId: String,
    combosAllowed: Boolean,
    couponExpiration: Number,
    couponId: String,
    customerReuses: Number,
    details: String,
    discountedPrice: Number,
    listPrice: Number,
    name: String,
    numberAvailable: Number
  },
  computed: {
    legal () {
      var expiration = this.couponExpiration
      var length
      if (expiration === 2160) length = 'ninety (90) days'
      if (expiration === 2880) length = 'one hundred twenty (120) days'
      if (expiration === 4320) length = 'six (6) months'
      if (expiration === 8760) length = 'one (1) year'

      var combosAllowed = this.combosAllowed
      var combos
      if (combosAllowed === true) combos = 'Valid'
      if (combosAllowed === false) combos = 'Not valid'

      var customerReuses = this.customerReuses
      var reuses
      if (customerReuses === 1) reuses = 'One (1) coupon'
      if (customerReuses === 2) reuses = 'Two (2) coupons'
      if (customerReuses === -1) reuses = 'Any number of coupons'

      return `Promotion lasts for ${length} from date of coupon claiming.
 No purchase necessary to participate. ${combos} with other certificates, vouchers, or offers.
 ${reuses} can be redeemed per household.`
    },
    priceDifference () {
      return Math.floor(((this.listPrice - this.discountedPrice) / this.listPrice) * 100.0)
    }
  },
  methods: {
    async claim () {
      this.loading = true
      var client = this.$store.getters.getCouponApigClientFactory
      var params = {
        business_id: this.businessId,
        coupon_id: this.couponId
      }
      var pathTemplate = '/businesses/{business_id}/claimcoupon/{coupon_id}'
      var method = 'GET'
      var additionalParams = {}
      var body = {}
      try {
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.loading = false
        this.$router.push('/messaging')
      } catch (error) {
        console.log(error)
        if (error.response.status === 409) {
          this.loading = false
          alert(error.response.data)
          this.$router.go(-1)
        }
      }
    }
  }
}
</script>

<style scoped>
.circle {
  height: 15px;
  width: 15px;
  background-color: #41ad49;
  border-radius: 50%;
  display: inline-block;
}

.discount-tag {
  background-color: var(--dark-color);
  border-radius: 10%;
  color: var(--secondary-background-color);
  display: inline-block;
  float: center;
  font-weight: bold;
}

.discounted-price {
  color: #41ad49 !important;
  display: inline;
}

.fa-clock {
  font-size: 3rem;
  color: rgb(79, 79, 79);
  margin: 10px;
}

.left-border {
  border-left: 1px solid rgba(0,0,0,.1);
}

.list-price {
  display: inline;
  text-decoration: line-through;
}

.number-available {
  font-size: 3rem;
}

@media (max-width: 768px) {
  .second {
    -ms-flex-order: 2;
    order: 2;
  }
}

.side-borders {
  border-left: 1px solid rgba(0,0,0,.1);
  border-right: 1px solid rgba(0,0,0,.1);
}

.bottom-border {
  border-bottom: 1px solid rgba(0,0,0,.1);
}

.text-right {
  text-align: right;
}

.top-border {
  border-top: 1px solid rgba(0,0,0,.1);
}

.clock-icon {
  font-size: 40px;
}

.display-number {
  font-size: 40px;
}

.big-text {
  font-size: 24px;
}

.biggish-text {
  font-size: 20px;
}

.fa-tags {
  color: var(--dark-color);
}
</style>



// WEBPACK FOOTER //
// src/components/business/subnavItems/Coupons.vue